import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export function useMutationSessionPackSubscriptionExpiryDate({
  api,
}: {
  api: ApiType;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      subscriptionId,
      expiryDate,
    }: {
      subscriptionId: number;
      userMemberId: string;
      expiryDate: string;
    }) =>
      (
        await api.memberApi.sessionPackSubscriptionExpiryDate({
          subscriptionId,
          expiryDate,
        })
      ).data,
    onSuccess: async (_, { userMemberId }) => {
      await queryClient.invalidateQueries({
        queryKey:
          memberQueryKeys.userMemberSessionPackSubscriptionCurrent(
            userMemberId,
          ),
      });
    },
  });
}
